import TiktokImage from 'assets/images/tiktok.svg'

import styles from './AuthorizationLogin.module.scss'

const TiktokLogin = () => (
  <div className={styles.tiktok}>
    <TiktokImage />
  </div>
)
export default TiktokLogin
